// extracted by mini-css-extract-plugin
module.exports = {"base":"TextBox_base__3i6IN","error":"TextBox_error__319Tb","errorText":"TextBox_errorText__2qMme"};